<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ZAb4YZ/tc-custom/9781504051569.jpg?1734293807496" alt="This image is the cover for the book Suspicious Circumstances"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Suspicious Circumstances
      </h1>
      <p class="bookDescription body article font2">
        <b>The Edgar Award–winning author of the Peter Duluth series delivers a fun, fast-paced murder mystery set in the heyday of Hollywood.</b><br/>  <br/> Patrick Quentin, best known for the Peter Duluth puzzle mysteries, also penned outstanding detective novels from the 1930s through the 1960s under other pseudonyms, including Q. Patrick and Jonathan Stagge. Anthony Boucher wrote: “Quentin is particularly noted for the enviable polish and grace which make him one of the leading American fabricants of the murderous comedy of manners; but this surface smoothness conceals intricate and meticulous plot construction as faultless as that of Agatha Christie.”<br/>  <br/> Young Nickie Rood is in Paris working on a novel, enjoying the company of a lovely local, and generally lazing about when he learns of the death of Hollywood icon Norma Delaney. His eccentric mother, Anny, demands that he return home at this trying time.<br/>  <br/> After all, Norma was one of Anny’s best friends. They had come up together, working their way to movie stardom. But they were also both facing the fact that stars fade. And with Norma’s unfortunate—and quite suspicious—demise, a plum film role is now Anny’s for the taking. Which is why she ends up cast as suspect number one in her friend’s murder.<br/>  <br/> With Anny’s life and legacy on the line, Nickie must snoop his way through the highest of high society and the grimiest gutters in Tinseltown if he’s going to keep his mother from facing her final act.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patrick Quentin
      </h2>
      
      <p class="authorDescription body article">Patrick Quentin, Q. Patrick, and Jonathan Stagge were pen names under which Hugh Callingham Wheeler (1912&ndash;1987), Richard Wilson Webb (1901&ndash;1966), Martha Mott Kelley (1906&ndash;2005), and Mary Louise White Aswell (1902&ndash;1984) wrote detective fiction. Most of the stories were written together by Webb and Wheeler, or by Wheeler alone. Their best-known creation is amateur sleuth Peter Duluth. In 1963, the story collection <I>The Ordeal of Mrs. Snow</I> was given a Special Edgar Award by the Mystery Writers of America.<BR /> &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      MysteriousPress.com/Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bbd29aca